import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { CalendarModule as AngularCalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ButtonModule } from '@openng/optimus-ui/button';
import { ButtonGroupModule } from '@openng/optimus-ui/buttongroup';
import { CalendarComponent } from './calendar/calendar.component';

@NgModule({
  exports: [CalendarComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslocoModule,
    AngularCalendarModule,
    ButtonModule,
    ButtonGroupModule,
    CalendarComponent
  ]
})
export class CalendarModule {
  static forRoot(): ModuleWithProviders<AngularCalendarModule> {
    return AngularCalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    });
  }
}
